import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { VIEW_PERMISSIONS_ROUTE_PATHS } from './config';

const lazyWithRetry = (importFn: () => Promise<{ default: React.ComponentType }>) =>
  lazy(() =>
    importFn().catch(() => {
      window.location.reload();
      return importFn();
    })
  );

export const VIEW_PERMISSIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'view-permissions',
    path: VIEW_PERMISSIONS_ROUTE_PATHS.viewPermissions,
    component: lazyWithRetry(() => import('./pages/view-permissions-page')),
    layout: 'default',
    permissions: { scopes: ['view-permissions'] },
    menu: {
      title: 'pages.admin.viewPermissions.title',
    },
  },
];
